import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PayloadDetail = _resolveComponent("PayloadDetail")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_PayloadComposition = _resolveComponent("PayloadComposition")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, {
        cols: "12",
        md: "6"
      }, {
        default: _withCtx(() => [
          (_ctx.zipFile && _ctx.payload)
            ? (_openBlock(), _createBlock(_component_PayloadDetail, {
                key: 0,
                zipFile: _ctx.zipFile,
                payload: _ctx.payload
              }, null, 8, ["zipFile", "payload"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_v_divider, { vertical: "" }),
      _createVNode(_component_v_col, {
        cols: "12",
        md: "6"
      }, {
        default: _withCtx(() => [
          (_ctx.zipFile && _ctx.payload.manifest)
            ? (_openBlock(), _createBlock(_component_PayloadComposition, {
                key: 0,
                manifest: _ctx.payload.manifest,
                demo: true
              }, null, 8, ["manifest"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}